document.documentElement.classList.remove('no-js');

(function () {
  'use strict';

  function showToast(message) {
    var t = document.querySelector('[data-toast]');
    if (!t) return;
    t.textContent = message;
    t.classList.add('is-visible');
    window.setTimeout(function () { t.classList.remove('is-visible'); }, 2600);
  }

  function updateCartCount(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });
  }

  async function addToCart(form) {
    var response = await fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { 'Accept': 'application/json' },
      body: new FormData(form)
    });
    if (!response.ok) {
      var error = {};
      try { error = await response.json(); } catch (e) {}
      throw new Error(error.description || 'Unable to add this item to the cart.');
    }
    return response.json();
  }

  // Add to Bag intentionally uses Shopify's native product form submission.
  // This keeps the theme compatible with Shopify's cart/product-form behavior.
  // Buy Now below uses AJAX so it can add the selected variant and then open checkout.

  document.addEventListener('click', function (event) {
    var buyBtn = event.target.closest('[data-buy-now]');
    if (!buyBtn) return;

    var section = buyBtn.closest('[data-product-section]');
    if (!section || buyBtn.disabled) return;

    event.preventDefault();

    var form = section.querySelector('[data-product-form]');
    var idInput = form && form.querySelector('[name="id"]');
    var variantId = idInput && idInput.value;
    if (!form || !variantId) {
      showToast('Please select an available option.');
      return;
    }

    var originalText = buyBtn.textContent;
    buyBtn.disabled = true;
    buyBtn.textContent = 'Please wait…';

    addToCart(form)
      .then(function () {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
        window.location.assign(root + 'checkout');
      })
      .catch(function (error) {
        buyBtn.disabled = false;
        buyBtn.textContent = originalText;
        showToast(error.message || 'Could not start checkout. Please try again.');
      });
  });

  function initVariantPicker(section) {
    var data = section.querySelector('[data-product-variants]');
    if (!data) return;

    var variants;
    try {
      variants = JSON.parse(data.textContent);
    } catch (e) {
      return;
    }

    var selects = Array.prototype.slice.call(section.querySelectorAll('[data-option-select]'));
    var idInput = section.querySelector('[name="id"]');
    var buttons = Array.prototype.slice.call(section.querySelectorAll('.btn-atb, .btn-buy'));

    if (!idInput || !selects.length) return;

    function syncVariant() {
      var values = selects.map(function (select) { return select.value; });
      var variant = variants.find(function (v) {
        return v.options && v.options.every(function (option, index) {
          return option === values[index];
        });
      });

      if (!variant) {
        idInput.value = '';
        buttons.forEach(function (button) {
          button.disabled = true;
          if (button.classList.contains('btn-atb')) button.textContent = 'Unavailable';
        });
        return;
      }

      idInput.value = variant.id;
      buttons.forEach(function (button) {
        button.disabled = !variant.available;
        if (button.classList.contains('btn-atb')) {
          button.textContent = variant.available ? 'Add to bag' : 'Sold out';
        }
      });

      var price = section.querySelector('[data-product-price]');
      if (price && window.Shopify && typeof Shopify.formatMoney === 'function') {
        price.firstChild.textContent = Shopify.formatMoney(variant.price, Shopify.money_format) + ' ';
      }
    }

    selects.forEach(function (select) {
      select.addEventListener('change', syncVariant);
    });
  }

  document.querySelectorAll('[data-product-section]').forEach(initVariantPicker);
  window.showToast = showToast;
})();
